import React, { CSSProperties, ReactElement } from 'react'

import { colors } from '@lmc/common/constants'

type Props = {
  color?: string
  cornerType?: 'round' | 'square'
  size?: 'default' | 'small'
  style?: object
  text?: string
  textColor?: string
}

export default function Badge({
  color = colors.grey,
  cornerType = 'round',
  size = 'default',
  style,
  text = 'BADGE',
  textColor = colors.black,
}: Props): ReactElement {
  let borderRadius
  let badgeStyle

  switch (cornerType) {
    case 'square':
      borderRadius = 0
      break
    default:
      borderRadius = 60
      break
  }

  switch (size) {
    case 'small':
      badgeStyle = {
        ...styles.basicStyles,
        ...styles.smallBadge,
        backgroundColor: color,
        borderRadius,
        color: textColor,
        whiteSpace: 'nowrap',
        ...style,
      }
      break
    default:
      badgeStyle = {
        ...styles.basicStyles,
        ...styles.defaultBadge,
        backgroundColor: color,
        borderRadius,
        color: textColor,
        whiteSpace: 'nowrap',
        ...style,
      }
      break
  }

  return <div style={badgeStyle as CSSProperties}>{text}</div>
}

const styles = {
  basicStyles: {
    fontWeight: 600,
    letterSpacing: 1,
    cursor: 'pointer',
  },
  defaultBadge: {
    fontSize: 12,
    marginLeft: 4,
    padding: '4px 12px',
  },
  smallBadge: {
    fontSize: 10,
    padding: '0px 10px',
    lineHeight: '16px',
  },
}
